<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-container ref="searchContainer" :scrId="scrId" />
				</sf-card>
			</div>
			<!--엑셀 업로드 팝업창 영역 시작-->
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-container ref="table" @PopupOpen="PopupOpen" @Refresh="Refresh" :scrId="scrId" />
					<excel-upload-modal :scrId="scrId" ref="excelUploadPop" @Refresh="Refresh" />
				</sf-card>
			</div>
			<!--엑셀 업로드 팝업창 영역 끝-->
		</div>
	</div>
</template>

<script>
import SearchContainer from './Search/SearchContainer.vue';
import TableContainer from './Table/TableContainer.vue';
import ExcelUploadModal from '@qms/Components/popup/ExcelUploadModal.vue'; //엑셀업로드 모달창
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: { SearchContainer, TableContainer, ExcelUploadModal },
	methods: {
		Refresh() {
			//$refs 는 컴포넌트에 ref로 정의한 이름으로 접근할때 사용한다.
			this.$refs.searchContainer.searchList();
		},
		PopupOpen(param) {
			//this.userName = param.userName;
			//console.log('ContentView 에서의 this.userName 값 ::::: ', param.url);
			// alert(this.$refs.searchView.userName);
			//this.$refs.searchView.open(param);
			// this.userName = param.userName;

			this.$refs.excelUploadPop.open(param); //ExcelUploadModal 팝업에 정의한 open팝업을 실행한다.
		} /*,
		sendData(param) {
			alert('최종 팝업화면에서 가지고온 데이터 ::::: url 는 ' + param.url + ', title은 ' + param.title);
		}
		*/
	}
};
</script>

<style></style>
